import {
  IoIosAirplane,
  MdDirectionsBoat,
  MdLocalShipping,
  MdTrain
} from '@fareye/utils'
import { dateFormatter as dateFormatterTimezone } from '@fareye/common'
import { displayTime } from '../components/Timeline/function'

export const columnMapping: any = {
  tripIdAndProduct: 'slug',
  routeDetails: 'origin',
  startAndEndTime: 'startDate',
  transitTime: 'actualTransitTime',
  eta: 'eta',
  exceptions: 'exceptionsCount',
  driverDetails: 'driverName',
  tripID: 'slug'
}
export const Svg: any = {
  air: IoIosAirplane,
  ocean: MdDirectionsBoat,
  road: MdLocalShipping,
  rail: MdTrain
}

function dateFormatterTz(val: any): any {
  return val ? dateFormatterTimezone(val, 'YYYYMMDDHHmmz') : ''
}

function dateFormatter(val: any) {
  return displayTime(val)
}
export const formatters: any = {
  dateFormatter,
  dateFormatterTz
}
export const inTransitConstant: any = {
  transporterPerformance: 'Transporters Performance Card',
  routeHeading: 'Route Performance',
  tripsLink: 'View All Trips',
  tripsCount: 'Trips',
  transitTime: 'Average Transit Time',
  exceptions: 'Exceptions',
  exception: 'Exception',
  transporterName: 'Transporter',
  transportMode: 'Shipment Modes',
  status: 'Shipment Statuses',
  inState: 'Shipment States',
  alertEventTypes: 'Exceptions',
  delayedBy: 'Delayed By',
  label: 'Label',
  onlyEarly: 'Early',
  delayed: 'Delayed',
  onlyOntime: 'On - Time',
  target: 'Target Time',
  timeDifference: 'Average Time Difference',
  transportersHeading: 'Transporters',
  transportLink: 'View All',
  sortingLabel: 'Sorting by',
  vehicleOnTimeScore: 'Vehicle On-Time Delivery Score',
  delayRoutes: 'Route with most delay',
  tripStatusLabel: 'Trips Status',
  alertsLabel: 'Alerts Triggered',
  pilferagesLabel: 'Pilferages',
  noAlertsLabel: 'No Alerts triggered',
  noPilferagesLabel: 'No Pilferages Found',
  onTimeDelivery: 'On-Time Delivery',
  returnMovement: 'Return Movement',
  inPlantExceptionLabel: 'In-Plant Exceptions',
  noInPlantExceptionLabel: 'No Alerts triggered',
  vehicleMetrics: 'Vehicle Metrics',
  onTimeScore: 'On-Time Delivery Score',
  noExceptions: 'No Alerts triggered',
  milestoneCarrierStatus: 'Milestones',
  all: 'All',
  advancedFilters: 'Advanced Filters',
  reset: 'Reset',
  applyFilters: 'Apply Filters',
  moreFilters: 'More Filters',
  to: 'to',
  tempRange: 'Temp. Range',
  toolTipWithinRangeContent: 'Temperature is in the normal range',
  toolTipOutsideRangeContent: 'Temperature exceeds the normal range',
  originName: 'Origin',
  consignerName: 'Consigner',
  statusToSource: 'Status to source',
  statusAtSource: 'Status at source',
  statusToDestination: 'Status to destination',
  statusAtDestination: 'Status at destination'
}

export const RoutesPath = {
  HOME: '/',
  INTRANSIT: '/in-transit',
  INTRANSIT_MAP: '/in-transit/map',
  INTRANSIT_TRANSPORTERS: '/in-transit/transporters',
  INTRANSIT_TRIPS: '/in-transit/trips',
  INTRANSIT_ETA: '/in-transit/eta',
  SHARE_TRIP_INTRANSIT: '/share/in-transit/trips',
  SHARE_TRIP_INPLANT: '/share/in-plant/trips',

  TRIP_DETAILS: '/trip-details',
  POI: '/poi',
  ADD_POI: '/poi/add',
  INPLANT: '/in-plant',
  INPLANT_MAP: '/in-plant/map',
  INPLANT_TRIPS: '/in-plant/trips',
  INDENT: '/indent',
  INDENT_VEHICLE: '/indent/vehicle',
  LOGIN: '/login',
  LOGOUT: '/logout',
  KPI: '/kpi',
  NEARBY: '/nearby',
  SETTINGS: '/settings',
  ALERT_SETTINGS: '/settings/alerts',
  KPI_EDITOR: '/kpi/editor',
  ALLOCATION: '/allocation',
  REPORT: '/report'
}

export const RoutesLabel = {
  KPI: 'KPI',
  KPI_PLAYGROUND: 'KPI Playground',
  INPLANT: 'In Plant',
  INPLANT_PERF: 'In Plant Performance',
  INPLANT_MAP: 'In Plant Map',
  INTRANSIT: 'InTransit',
  INTRANSIT_PERF: 'InTransit Performance',
  INTRANSIT_TRANSPORTERS: 'Transporters',
  INTRANSIT_ETA: 'E. T. A',
  INTRANSIT_MAP: 'InTransit Map',
  INTRANSIT_TRIPS: 'InTransit Trips',
  INDENT: 'Indent',
  INDENT_LIST: 'Indent List',
  INDENT_VEHICLE: 'Vehicle List',
  TRIP_DETAILS: 'Trip Details',
  POI: 'Poi',
  ETA: 'Eta',
  LOGIN: 'Login',
  LOGOUT: 'Logout',
  NEARBY: 'Nearby',
  ALLOCATION: 'Allocation',
  ALLOCATION_LIST: 'Allocation List',
  ALERTS: 'Alerts',
  ALERT_SETTINGS: 'Alerts',
  Report: 'report'
}

export const baseURL = 'https://tpt-preprod.fareye.co'

export const SHIPMENT_TYPES = [
  { label: 'Shipment', value: 'journey', dataSource: 'Journey' },
  { label: 'Package', value: 'package', dataSource: 'Package' },
  { label: 'Ocean Container', value: 'container', dataSource: 'Container' }
  // { label: 'Item', value: 'item', dataSource: 'Item' }
]
export const PARCEL_TYPES = [
  {
    label: 'Forward Delivery',
    value: 'forward',
    dataSource: 'Package',
    key: 'forward',
    mapping: 'type_of_order'
  },
  {
    label: 'Reverse Pickup',
    value: 'backward',
    dataSource: 'Package',
    key: 'forward',
    mapping: 'type_of_order'
  }
  // { label: 'Item', value: 'item', dataSource: 'Item' }
]
export const TimeLineData = [
  {
    rawMilestoneName: 'order_created',
    milestoneName: 'Order Created',
    sequenceNo: 0,
    isCompleted: true,
    status: null,
    packageStatus: null,
    milestoneRawStatus: null,
    milestoneEventTime: null
  },
  {
    rawMilestoneName: 'available_for_pickup',
    milestoneName: 'Available For Pickup',
    sequenceNo: 1,
    isCompleted: true,
    status: null,
    packageStatus: null,
    milestoneRawStatus: null,
    milestoneEventTime: null
  },
  {
    rawMilestoneName: 'in_transit',
    milestoneName: 'In Transit',
    sequenceNo: 2,
    isCompleted: true,
    status: null,
    packageStatus: null,
    milestoneRawStatus: null,
    milestoneEventTime: null
  },
  {
    rawMilestoneName: 'at_destination_hub',
    milestoneName: 'At Destination Hub',
    sequenceNo: 3,
    isCompleted: true,
    status: null,
    packageStatus: null,
    milestoneRawStatus: null,
    milestoneEventTime: null
  },
  {
    rawMilestoneName: 'out_for_delivery',
    milestoneName: 'Out For Delivery',
    sequenceNo: 4,
    isCompleted: false,
    status: null,
    packageStatus: null,
    milestoneRawStatus: null,
    milestoneEventTime: null
  },
  {
    rawMilestoneName: 'delivered',
    milestoneName: 'Delivered',
    sequenceNo: 5,
    isCompleted: false,
    status: null,
    packageStatus: null,
    milestoneRawStatus: null,
    milestoneEventTime: null
  }
]

export const APP_CONSTANTS = {
  LS_AUTOREFRESH: 'UIAutoRefresh'
}

export const publicTerminalViewConfig = {
  children: {
    arrival: {
      component: 'TerminalView',
      config: {
        apiConfig: {
          apiURL: '/api/v3/terminal/arrivals'
        },
        columns: [
          {
            label: 'route',
            key: 'consignerName'
          },
          {
            label: 'status',
            key: 'status'
          },
          {
            label: 'sta',
            key: 'sta',
            formatter: 'dateFormatter'
          },
          {
            label: 'eta',
            key: 'etaOrSta',
            formatter: 'dateFormatter'
          }
        ]
      }
    },
    departure: {
      component: 'TerminalView',
      config: {
        apiConfig: {
          apiURL: '/api/v3/terminal/departures'
        },
        callWithoutSubFilter: true,
        carryDate: true,
        columns: [
          {
            label: 'route',
            key: 'consignerName'
          },
          {
            label: 'status',
            key: 'status'
          },
          {
            label: 'std',
            key: 'std',
            formatter: 'dateFormatter'
          },
          {
            label: 'next stop',
            key: 'nextStop'
          }
        ]
      }
    }
  },
  page: {
    dataRefreshTimeInterval: 600,
    paginationTimeInterval: 5000,
    rowSize: 5,
    maxPageLimit: 10
  }
}

export const hubsConfig = {
  shareURL: '/api/v3/terminal/generate_share_slug_for_terminal_visibility',
  hubList: {
    apiURL: '/api/v3/terminal/hubs'
  }
}

export const DEVICE_CONFIG = {
  devices: '/api/v3/map_imei/devices/gps_dashboard',
  search: '/api/v3/map_imei/devices/gps_dashboard_search',
  deviceHistoryPathParam: '/api/v3/map_imei/device/device_histories',
  exportDevice: '/streams/map_imei/devices/gps_dashboard_export_data'
}

export const HEADER_INFLECTION = {
  headers: { 'Key-Inflection': 'camel', 'X-Change-Case': true }
}

export const initialState = {
  data: [],
  isLoading: false,
  isSuccess: true,
  isError: false,
  message: '',
  meta: {}
}